module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align center cf spacer--small",
    attrs: {
      "id": "faces-app"
    }
  }, [_c('div', {
    staticClass: "column--half-br dib center kr-sans"
  }, [_c('face-features', {
    attrs: {
      "feature": _vm.koreanEye
    },
    on: {
      "change": _vm.change
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "faces-display spacer--small"
  }, [_vm._v(_vm._s(_vm.koreanEye.active) + _vm._s(_vm.koreanMouth.active) + _vm._s(_vm.koreanEye.active))]), _vm._v(" "), _c('face-features', {
    attrs: {
      "feature": _vm.koreanMouth
    },
    on: {
      "change": _vm.change
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column--half-br dib center en-faces"
  }, [_c('face-features', {
    attrs: {
      "feature": _vm.englishEyes
    },
    on: {
      "change": _vm.change
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "faces-display spacer--small"
  }, [_vm._v(_vm._s(_vm.englishEyes.active) + " " + _vm._s(_vm.englishMouth.active))]), _vm._v(" "), _c('face-features', {
    attrs: {
      "feature": _vm.englishMouth
    },
    on: {
      "change": _vm.change
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c430726e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faces.vue
// module id = 155
// module chunks = 0